import { Accordion } from "@circleco/compass/components/Accordion";

import { t } from "@/i18n-js/instance";
import { ReportsList } from "@/react/components/SettingsApp/Moderation/ReportFlaggedContentModal/CompassModal/ReportTab/ReportsList";
import { VisibilityInfo } from "@/react/components/SettingsApp/Moderation/ReportFlaggedContentModal/CompassModal/ReportTab/VisibilityInfo";
import { useMemberConnectionReports } from "@/react/components/SettingsApp/Moderation/ReportFlaggedContentModal/useMemberConnectionReports";
import {
  CHAT_ROOM_MESSAGE_TYPE,
  CONNECT_CONNECTION_TYPE,
} from "@/react/types/FlaggedContent";
import type {
  FlaggedContent,
  FlaggedContentReport,
  FlaggedContentableType,
} from "@/react/types/FlaggedContent";

const i18nRoot = "settings.moderation.review_flagged_content_modal";

export interface ReportsAccordionPanelProps {
  currentReportFallback?: FlaggedContentReport;
  currentReportId?: number;
  flaggedContent?: FlaggedContent;
  flaggedContentId?: string;
  reports: FlaggedContentReport[];
  reportsCount?: number;
  type?: FlaggedContentableType;
}

export const ReportsAccordionPanel = ({
  flaggedContent,
  flaggedContentId,
  currentReportId,
  currentReportFallback,
  reports,
  reportsCount,
  type,
}: ReportsAccordionPanelProps) => {
  const isConnection = type === CONNECT_CONNECTION_TYPE;

  const {
    reports: connectionReports,
    hasNextPage,
    fetchNextPage,
    isLoading,
  } = useMemberConnectionReports(isConnection ? flaggedContentId : undefined);

  const displayedReports = isConnection ? connectionReports : reports;
  const totalCount =
    reportsCount ??
    (isLoading && displayedReports.length === 0
      ? reports.length
      : displayedReports.length);

  return (
    <div className="flex flex-col gap-4">
      <VisibilityInfo content={flaggedContent} />
      <Accordion.Root isBoxed>
        <Accordion.Item value="reports">
          <Accordion.Trigger>
            {t([i18nRoot, "reports_count"], { count: totalCount })}
          </Accordion.Trigger>
          <Accordion.Content>
            <ReportsList
              currentReportId={currentReportId}
              currentReportFallback={
                isConnection || type === CHAT_ROOM_MESSAGE_TYPE
                  ? currentReportFallback
                  : undefined
              }
              reports={displayedReports}
              type={type}
              hasNextPage={hasNextPage}
              isLoading={isLoading}
              onLoadMore={fetchNextPage}
            />
          </Accordion.Content>
        </Accordion.Item>
      </Accordion.Root>
    </div>
  );
};
